import apiService from "./apiService";

export default {
  /**
   * Get estimated collection sizes
   * @returns {Promise}
   */
  async getCollectionStats() {
    return apiService.get("api/firebase/stats/collections");
  },

  /**
   * Get usage statistics
   * @returns {Promise}
   */
  async getUsageStats() {
    return apiService.get("api/firebase/stats/usage");
  },

  /**
   * Fetch a single Firebase object by collection and ID
   * @param {string} collection
   * @param {string} id
   * @returns {Promise}
   */
  async getObjectById(collection, id) {
    return apiService.get("api/firebase/collection/" + collection + "/object/" + id);
  },

  /**
   * Delete a single Firebase object by collection and ID
   * @param {string} collection
   * @param {string} id
   * @returns {Promise}
   */
  async deleteObject(collection, id) {
    return apiService.delete("api/firebase/collection/" + collection + "/object/" + id);
  },
};



// WEBPACK FOOTER //
// ./src/services/FirebaseStatsService.js